import { createSlice } from "@reduxjs/toolkit";

export const ClientTab = createSlice({
  name: "client",
  initialState: {
    active: "bussiness",
  },
  reducers: {
    setClientTab: (state, action) => {
      state.active = action.payload;
    },
  },
});

export const { setClientTab } = ClientTab.actions;

export default ClientTab.reducer;
